/* eslint-disable @typescript-eslint/no-unused-vars */
export const getFlexBasis = ({
	length,
	isPortrait
}: {
	length: number;
	isPortrait: boolean;
}): number => {
	let flexBasis: number = 100 / 4;

	if (length <= 6) {
		flexBasis = 100 / 3;
		if (length <= 4) {
			flexBasis = 100 / 2;
		}
	}

	if (isPortrait) {
		flexBasis = 100 / length;
	}

	return flexBasis;
};
